var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.error
      ? _c("div", { staticClass: "card-item transition-slow" }, [
          _c("div", { staticClass: "info-content" }, [
            _c(
              "div",
              { staticClass: "info-item" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "return-link",
                    attrs: { to: { name: "login" } },
                  },
                  [
                    _c("span", { class: "fas fa-arrow-left" }),
                    _vm._v(" Ir al login "),
                  ]
                ),
                _c("h2", { staticClass: "login-title" }, [
                  _vm._v("Restablecer contraseña"),
                ]),
                _vm._m(0),
                _vm.error
                  ? _c("p", { staticClass: "description-password" }, [
                      _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
                    ])
                  : _vm._e(),
                _vm._m(1),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "spinner-content",
        class: _vm.isLoading ? "is-loading" : "",
      },
      [_vm._m(2)]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "developer" }, [
      _c("img", { attrs: { src: require("@/ui/assets/img/developer.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "description-help" }, [
      _vm._v(" ¿Necesitas ayuda? Escríbenos a "),
      _c("a", { attrs: { href: "mailto:hola@creditu.com" } }, [
        _vm._v("hola@creditu.com"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "spinner" }, [
      _c("div", { staticClass: "double-bounce1" }),
      _c("div", { staticClass: "double-bounce2" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }